import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading|no-user, resolved via `ready`
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    await refresh();
    return data;
  };

  const loginWithOtp = async ({ phone, code, name }) => {
    const { data } = await api.post("/auth/otp/verify", { phone, code, name });
    await refresh();
    return data;
  };

  const sendOtp = async (phone) => {
    const { data } = await api.post("/auth/otp/send", { phone });
    return data;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    await refresh();
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      // ignore network errors on logout; still clear local state
    }
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, loginWithOtp, sendOtp, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
